import axios from "axios";

export const downloadDailyChanges = async () => {
  const token = localStorage.getItem("token");

  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_BASE_URL}/export-csv/daily-report`,
      {
        responseType: "blob",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (!response.data || response.data.size === 0) {
      alert("No changes found for today.");
      return;
    }

    // Create a blob with the correct type for Excel
    const blob = new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const url = window.URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;

    const fileName = `daily_changes_${new Date().toISOString().split("T")[0]}.xlsx`;
    link.download = fileName;

    document.body.appendChild(link); 
    link.click();
    document.body.removeChild(link);

    window.URL.revokeObjectURL(url);
  } catch (err) {
    console.error("Failed to download daily Excel report", err);
    alert("No changes found for today.");
  }
};
